import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import ThumbUpIcon from 'mdi-react/ThumbUpIcon';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

const SentimentBadge = ({ badge, minPositive, showNrOfReviewsAs }) => {
  const { t } = useContext(AppContext);

  if (badge.nrOfPositiveReviews < minPositive) {
    return null;
  }

  const renderNumberOfReviews = () =>
    showNrOfReviewsAs === 'text'
      ? t('product', 'sentiment-badge.n-related-reviews', {
          n: badge.nrOfReviews,
        })
      : `(${badge.nrOfReviews})`;

  const textElement = (
    <S.Text>
      <span>
        {t('product', `sentiment-badge.${badge.name}-${badge.sentiment}`)}
      </span>
      <S.RelatedReviews>
        {showNrOfReviewsAs && renderNumberOfReviews()}
      </S.RelatedReviews>
    </S.Text>
  );

  return (
    <S.Badge>
      <ThumbUpIcon size={16} />
      {textElement}
    </S.Badge>
  );
};

SentimentBadge.propTypes = {
  badge: PropTypes.shape({
    name: PropTypes.string,
    sentiment: PropTypes.oneOf(['positive', 'negative']),
  }),
  minPositive: PropTypes.number,
  showNrOfReviewsAs: PropTypes.oneOf(['number', 'text']),
};

SentimentBadge.defaultProps = {
  badge: null,
  minPositive: 2,
  showNrOfReviewsAs: undefined,
};

export default memo(SentimentBadge);
